import { DriverNotificationStopDocumentsAdded } from "../../../ducks/app/notifications/types";
import { useTranslation } from "react-i18next";

const InAppRouteUpdatedNotification = ({
  notification,
}: {
  notification: DriverNotificationStopDocumentsAdded;
}) => {
  const { t } = useTranslation("notifications");

  return (
    <div>
      {t("stopDocumentsAdded.title", { stopName: notification.data.stopName })}
    </div>
  );
};

export default InAppRouteUpdatedNotification;
